import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {DjPsycho} from "../DjPsycho";
import {DjPsychoGameAssets} from "../DjPsychoGameAssets";
import {TimelineLite} from "gsap";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";

export class DjPsychoWinView extends PIXI.Container implements StageLayer {
    private _fxWinFrameItems: TimelineSprite[][] = [];
    private _fxWinItems: TimelineSprite[][] = [];
    private _symAppearItemFs: TimelineSprite[][] = [];
    private _symRevealItems: TimelineSprite[][] = [];
    private _symAppearArray: TimelineSprite[][][];

    constructor() {
        super();
        this.name = "DjPsychoWinView";

        this.init();
    }

    public groupWinAnim(reelWinPositions: boolean[][], multipliedAmount: number, multiplierValue: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite();

        for (let reelId: number = reelWinPositions.length - 1; reelId >= 0; reelId--) {
            const winClusterIndex: number = reelWinPositions[reelId].lastIndexOf(true);
            if (winClusterIndex > -1) {
                const posX: number = DjPsycho.reelViewX + (reelId * DjPsycho.symbolWidth + DjPsycho.symbolWidth / 2) + (reelId * DjPsycho.padding);
                const posY: number = DjPsycho.reelViewY + (winClusterIndex * DjPsycho.symbolHeight);
                tl.add(this.winAmountAnimationByGroup(posX, posY, multipliedAmount, multiplierValue), 0);
                break;
            }
        }

        return tl;
    }

    public playWinAnimation(reel: number, row: number, canPlayFrame: boolean): TimelineLite {
        const tl: TimelineLite = new TimelineLite(),
            fxWin: TimelineSprite = this._fxWinItems[reel][row];

        if (canPlayFrame) {
            const fxWinFrame: TimelineSprite = this._fxWinFrameItems[reel][row];
            tl.add(fxWinFrame.getAnimationAutoShowHide(true, true), 0);
        }

        tl.add(fxWin.getAnimationAutoShowHide(true, true), 0);
        return tl;
    }

    public anticipateAppearAnimation(reel: number, row: number, index: number): void {
        if (DjPsycho.model.data.mode.indexOf("NORMAL") == -1 && DjPsycho.model.data.nextMode.indexOf("NORMAL") == -1) {
            this._symAppearItemFs[reel][row].playLoop();
            this._symAppearItemFs[reel][row].show();
        } else {
            this._symAppearArray[index][reel][row].playLoop();
            this._symAppearArray[index][reel][row].show();
        }
    }

    public stopAppearAnimation(reel: number, row: number): void {
        for (let index: number = 0; index < this._symAppearArray.length; index++) {
            this._symAppearArray[index][reel][row].hide();
            this._symAppearArray[index][reel][row].stopLoop();
        }
        this._symAppearItemFs[reel][row].hide();
        this._symAppearItemFs[reel][row].stopLoop();
    }

    public playRevealAnimation(reel: number, row: number): TimelineLite {
        return this._symRevealItems[reel][row].getAnimationAutoShowHide(true, true);
    }

    private winAmountAnimationByGroup(posX: number, posY: number, amount: number, multiplierValue: number): TimelineLite {
        const multipliedAmountText: PIXI.BitmapText = new PIXI.BitmapText(amount.toFixed(2), {
                fontName: DjPsychoGameAssets.BITMAP_FONT_WIN_COUNT_UP,
                fontSize: 12
            }),
            multiplierText: PIXI.BitmapText = new PIXI.BitmapText("x" + multiplierValue, {
                fontName: DjPsychoGameAssets.BITMAP_FONT_SYM_MULTIPLIER,
                fontSize: 22
            }),
            canPumpAmount: boolean = ((amount / DjPsycho.model.gameData.playedBetValue) >= 25),
            tl: TimelineLite = new TimelineLite();

        if (multipliedAmountText.width > DjPsycho.symbolWidth) {
            const scale: number = DjPsycho.symbolWidth / multipliedAmountText.width;
            multipliedAmountText.scale.set(scale);
        }
        multiplierText.visible = multiplierValue !== 1;

        tl.add(() => {
            multipliedAmountText.position.set(posX, posY);
            (<PIXI.Point>multipliedAmountText.anchor).set(0.5);
            this.addChild(multipliedAmountText);
            multiplierText.position.set(posX, posY + 50);
            (<PIXI.Point>multiplierText.anchor).set(0.5);
            this.addChild(multiplierText);
        });
        tl.to(multipliedAmountText, {duration: (15 / 30), y: posY - 70}, 0);
        tl.to(multiplierText, {duration: (15 / 30), y: posY - 20}, 0);

        // #119
        if (canPumpAmount) {
            tl.to(multipliedAmountText.scale, {
                duration: 6 / 30,
                x: 1.3,
                y: 1.3
            });
            tl.to(multipliedAmountText.scale, {
                duration: 3 / 30,
                x: 1,
                y: 1
            });
        }

        tl.add(() => {
            multipliedAmountText.parent?.removeChild(multipliedAmountText);
            multiplierText.parent?.removeChild(multiplierText);
        });
        return tl;
    }

    private init(): void {
        let fxWinFrame: TimelineSprite,
            fxWin: TimelineSprite,
            symAppear: TimelineSprite,
            symAppear2: TimelineSprite,
            symAppear3: TimelineSprite,
            symAppearFs: TimelineSprite,
            symReveal: TimelineSprite,
            item1: TimelineSprite[][] = [],
            item2: TimelineSprite[][] = [],
            item3: TimelineSprite[][] = [];

        for (let reel: number = 0; reel < DjPsycho.reelsNum; reel++) {
            this._fxWinFrameItems.push([]);
            this._fxWinItems.push([]);
            this._symAppearItemFs.push([]);
            this._symRevealItems.push([]);
            item1.push([]);
            item2.push([]);
            item3.push([]);

            for (let row: number = 0; row < DjPsycho.rowsNum; row++) {
                fxWinFrame = new TimelineSprite(DjPsycho.assetLoader.getTextures("FX_Win_Frame/FX_Win_Frame_"));
                fxWinFrame.hide();
                fxWinFrame.anchor.set(0.5);
                fxWinFrame.blendMode = PIXI.BLEND_MODES.ADD;
                fxWinFrame.position.set((DjPsycho.reelViewX + (reel * DjPsycho.symbolWidth) + DjPsycho.symbolWidth / 2 + (reel * DjPsycho.padding)), (DjPsycho.reelViewY + (row * DjPsycho.symbolHeight) + (row * DjPsycho.padding)));
                this._fxWinFrameItems[reel].push(fxWinFrame);

                fxWin = new TimelineSprite(DjPsycho.assetLoader.getTextures("FX_Win/FX_Win_"));
                fxWin.hide();
                fxWin.anchor.set(0.5);
                fxWin.blendMode = PIXI.BLEND_MODES.ADD;
                fxWin.position = fxWinFrame.position;
                this._fxWinItems[reel].push(fxWin);

                symAppear = new TimelineSprite(DjPsycho.assetLoader.getTextures("Spin_FX/Spin_FX_"));
                symAppear.hide();
                symAppear.anchor.set(0.5);
                symAppear.position = fxWinFrame.position;
                symAppear.blendMode = PIXI.BLEND_MODES.ADD;
                item1[reel].push(symAppear);

                symAppear2 = new TimelineSprite(DjPsycho.assetLoader.getTextures("Spin_FX_2/Spin_FX_2_"));
                symAppear2.hide();
                symAppear2.anchor.set(0.5);
                symAppear2.position = fxWinFrame.position;
                symAppear2.blendMode = PIXI.BLEND_MODES.ADD;
                item2[reel].push(symAppear2);

                symAppear3 = new TimelineSprite(DjPsycho.assetLoader.getTextures("Spin_FX_3/Spin_FX_3_"));
                symAppear3.hide();
                symAppear3.anchor.set(0.5);
                symAppear3.position = fxWinFrame.position;
                symAppear3.blendMode = PIXI.BLEND_MODES.ADD;
                item3[reel].push(symAppear3);

                symAppearFs = new TimelineSprite(DjPsycho.assetLoader.getTextures("Spin_FX_Charge/Spin_FX_Charge_"));
                symAppearFs.hide();
                symAppearFs.anchor.set(0.5);
                symAppearFs.position = fxWinFrame.position;
                symAppearFs.blendMode = PIXI.BLEND_MODES.ADD;
                this._symAppearItemFs[reel].push(symAppearFs);

                symReveal = new TimelineSprite(DjPsycho.assetLoader.getTextures("Sym_Reveal/Sym_Reveal_"));
                symReveal.hide();
                symReveal.anchor.set(0.5);
                symReveal.position = fxWinFrame.position;
                this._symRevealItems[reel].push(symReveal);

                this._symAppearArray = [item1, item2, item3];
                this.addChild(fxWinFrame, fxWin, symAppear, symAppear2, symAppear3, symAppearFs, symReveal);
            }
        }
    }
}